import api from "./apiService";

export const getMySurveys = async ({ status, search, cursor, limit = 15 } = {}) => {
  const params = {};
  
  if (status !== undefined && status !== null) params.status = status;
  if (search) params.search = search;
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;

  return api.get("/survey/my-surveys", { params });
};

export const getMySurveyOverview = (surveyId) =>
  api.get(`/survey/my-surveys/${surveyId}/overview`);

export const getMySurveyResponses = (surveyId, params = {}, config = {}) =>
  api.get(`/survey/my-surveys/${surveyId}/responses`, { ...config, params });

export const getMySurveyResponseDetails = (surveyId, participantId, config = {}) =>
  api.get(`/survey/my-surveys/${surveyId}/responses/${participantId}`, config);

export const archiveSurvey = async (surveyId) => {
  return api.post("/survey/archive-survey", { survey_id: surveyId });
};

export const closeSurvey = async (surveyId) => {
  return api.post("/survey/close-survey", { survey_id: surveyId });
};

export const cloneSurvey = async (surveyId) => {
  return api.post("/survey/clone-survey", { survey_id: surveyId });
};

export const removeSavedSurvey = async (surveyId) => {
  return api.delete("/survey/remove-saved-survey", { data: { survey_id: surveyId } });
};

export const getMySurveyEngagement = async (surveyId) => {
  return api.get(`/survey/my-surveys/${surveyId}/engagement`);
};

export const getMySurveyEngagementReplies = async (surveyId, commentId) => {
  return api.get(`/survey/my-surveys/${surveyId}/engagement/comments/${commentId}/replies`);
};

export const likeMySurveyComment = async (surveyId, commentId) => {
  return api.post(`/survey/my-surveys/${surveyId}/engagement/comments/${commentId}/like`);
};

export const replyMySurveyComment = async (surveyId, commentId, data) => {
  return api.post(`/survey/my-surveys/${surveyId}/engagement/comments/${commentId}/reply`, data);
};

const mySurveyService = {
  getMySurveys,
  getMySurveyOverview,
  getMySurveyResponses,
  archiveSurvey,
  closeSurvey,
  cloneSurvey,
  removeSavedSurvey,
  getMySurveyEngagement,
  getMySurveyEngagementReplies,
  likeMySurveyComment,
  replyMySurveyComment,
};

export default mySurveyService;
